
export const myToolbar = {};

myToolbar.initialize = () => {
    myToolbar.disableTool('Soup');
    myToolbar.disableTool('Cloud');
};

myToolbar.focus = toolName => {
    const tool = b3.store.state.tools.find(element => element.name === toolName);
    b3.store.state.tools.forEach((_tool) => {
        if (_tool.panel) return // don't unfocus the clone tool
        _tool.isFocused = false;
    });
    tool.isFocused = true;
};

myToolbar.isDisabled = toolName => {
    const tool = b3.store.state.tools.find(element => element.name === toolName);
    return !!tool.disabled;
}

myToolbar.disableTool = toolName => {
    const tool = b3.store.state.tools.find(element => element.name === toolName);
    if (!tool) return;
    if (tool.disabled) return;
    tool.disabled = true;
};

myToolbar.enableTool = toolName => {
    const tool = b3.store.state.tools.find(element => element.name === toolName);
    if (!tool) return;
    if (!tool.disabled) return;
    tool.disabled = false;
};
